import React, { useContext, useEffect, useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import DateControl from "../../Components/DateControl";
import ErrorField from "../../Components/ErrorField";
import PatientDetails from "../../Components/PatientInformation";
import SaveAndNavigate from "../../Components/SaveAndNavigate";
import SideBarMenu from "../../Components/SideBarMenu";
import { AppContext } from "../../Contexts/AppContextProvider";
import {
  HTTPResponse,
  SideMenuItems,
  ToastMessages,
  ToastMessageType,
  Values,
} from "../../Helpers/Enums";
import {
  CommonError_Msgs,
} from "../../Helpers/HelperText";
import {
  GetLocalStorageData,
  GetLoggedInUserID,
  AllowOnlyIntegers,
  GetChartDateStr,
  GetEarliestDate,
  IsDateInvalid,
  IsDateValid,
  ValueInRange,
  AdjustDays,
  DateValid,
  applySidebarState,
  toggleSidebar,
  AllowOnlyNumbersWithTwoDecimals,
  IsAdmin,
  IsDateAfter,
  GetMaxDate,
  AddLocalStorageData
} from "../../Helpers/Utilities";

import { DemographicService } from "../../WebApiServices/Demographic.service";
import CustomTextArea from "../../Components/CustomTextArea ";

const Demographics = () => {
  const navigatePaths = {
    prevPage: "/EligibilityCriteria",
    currPage: "/Demographics",
    nextPage: "/ClinicalCharacteristics",
  };
  const { ShowToast, ToggleLoader, HandleSessionTimeout, isSideMenuActive, setisSideMenuActive,ShowActionPopUp, } =
    useContext(AppContext);
  const [stateList, setStateList] = useState([]);
  const pidRef = useRef(0);
  const [showTopErrMsg, setShowTopErrMsg] = useState(false);
    const [patientLocked, setpatientLocked] = useState(false);

  const indexDtInit = "index date";
  const indexMinus1DayInit = "index date - 1 day";
  const indexMinus365DaysInit = "index date - 365 days";
  const birthDtInit = "birth date";


  const [dates, setDates] = useState({
    indexDt: indexDtInit,
    indexMinus1Day: null,
    indexMinus365Days: null,
    birthDt: null,
    surveyDt: null,
    indexPlus548Days: null,
    eighteenMonthFollowUpDt: null,
  });

  const [demoDetails, setDemoDetails] = useState({
    //1
    rbl_birth: null,
    birth_dt: null,
    isBirthChanged:false,
    //2
    rbl_mma_diagnosis: null,
    mma_diagnosis_dt: null,
    chk_mma_diagnosis_dt_est:false,

    //3 new
    rbl_disease_onset: null,
    disease_onset_dt: null,
    chk_disease_onset_dt_est: false,

    //4
    rbl_gender: null,
    //5
    chk_race_american: false,
    chk_race_asian: false,
    chk_race_black: false,
    chk_race_hawaiian: false,
    chk_race_white: false,
    chk_race_oth: false,
    rb_race_unk: false,
    chk_race_hispanic: false,
    chk_race_middle_eastern: false,

    //6
    dd_state_id: null,
    state_name: "Select State",
    //7
    chk_insurance_commercial: false,
    chk_insurance_medicare: false,
    chk_insurance_medicaid: false,
    chk_insurance_military: false,
    chk_insurance_oth: false,
    txt_insurance_oth: "",
    rbl_insurance: null,
    //8
    rbl_mma_mut_genotype_first_allele: null,
    txt_mma_mut_genotype_first: "",

    rbl_mma_mut_genotype_second_allele: null,
    txt_mma_mut_genotype_second: "",
    //9
    rbl_wt_assess: null,
    wt_assess_dt: null,
    chk_wt_assess_dt_est: false,
    rbl_wt_measure: null,
    txt_wt_measure_kg: "",
    txt_wt_measure_lbs: "",
    //10
    rbl_ht_assess: null,
    ht_assess_dt: null,
    chk_ht_assess_dt_est: false,
    rbl_ht_measure: null,
    txt_ht_measure_ft: "",
    txt_ht_measure_in: "",
    txt_ht_measure_cm: "",
    //11
    rbl_head_circ_assess: null,
    head_circ_assess_dt: null,
    chk_head_circ_assess_dt_est: false,
    rbl_head_circ_measure: null,
    txt_head_circ_measure_in: "",
    txt_head_circ_measure_cm: "",
    //12
    last_encounter_dt: null,
    //13
    rbl_death: null,
    death_dt: null,
    chk_death_dt_est: false,
    //14
    chk_death_cause_mde: false,
    chk_death_cause_hyperammonemia: false,
    chk_death_cause_metabolic_acidosis: false,
    chk_death_cause_lactatemia: false,
    chk_death_cause_lt_lkt: false,
    chk_death_cause_severe_mma_symptoms: false,
    chk_death_cause_infection: false,
    chk_death_cause_oth: false,
    txt_death_cause_oth: "",
    rb_death_cause_unk: false,
    //15
    chk_prior_comorb_diabetes_1: false,
    chk_prior_comorb_diabetes_2: false,
    chk_prior_comorb_osteoporosis: false,
    rb_prior_comorb_none: false,
    //16
    chk_after_comorb_diabetes_1: false,
    chk_after_comorb_diabetes_2: false,
    chk_after_comorb_osteoporosis: false,
    rb_after_comorb_none: false,
    //17
    rbl_first_center_tmt: null,
    first_center_tmt_dt: null,
    chk_first_center_tmt_dt_est: false,
    //18
    rbl_last_center_tmt: null,
    last_center_tmt_dt: null,
    chk_last_center_tmt_dt_est: false,
  });
  const InitialHardErrList = {
    //1
    birth_empty: false,
    birth_dt_empty: false,
    birth_dt_invalid: false,
    //2
    mma_diagnosis_empty: false,
    mma_diagnosis_dt_empty: false,
    mma_diagnosis_dt_invalid: false,
    //3
    gender_empty: false,
    //4
    race_empty: false,
    //5
    ethnicity_empty: false,
    //6
    state_empty: false,
    //7
    insurance_commercial_empty: false,
    //8
    mma_mut_genotype_first_empty: false,
    mma_mut_genotype_second_empty: false,
    //9
    wt_assess_empty: false,
    wt_assess_dt_empty: false,
    wt_assess_dt_invalid: false,

    wt_measure_empty: false,
    wt_measure_invalid: false,
    //10
    ht_assess_empty: false,
    ht_assess_dt_empty: false,
    ht_assess_dt_invalid: false,

    ht_measure_empty: false,
    ht_measure_invalid: false,
    //11
    head_circ_assess_empty: false,
    head_circ_assess_dt_empty: false,
    head_circ_assess_dt_invalid: false,

    head_circ_measure_empty: false,
    head_circ_measure_invalid: false,


    //3new
    disease_onset_empty: false,
    disease_onset_dt_empty: false,
    disease_onset_dt_invalid: false,
  };
  const [hardErrList, setHardErrList] = useState(InitialHardErrList);

  const [ccFirstEncounterDate, setCCFirstEncounterDate] = useState("");
  const [newTransplantMaxDate, setnewTransplantMaxDate] = useState("");
   const [newBegginingFollowupDate, setnewBegginingFollowupDate] = useState("");
  useEffect(() => {
    async function FetchData() {
      pidRef.current = GetLocalStorageData("patientId") || 0;
      if (pidRef.current !== 0) {
        ToggleLoader(true);
        await LoadData();
        ToggleLoader(false);
      }
    }
    FetchData();
  }, []);
  async function LoadData() {
    try {
      const response = await DemographicService.LoadData(pidRef.current);
      if (response?.status === HTTPResponse.OK) {
        const { data } = response;
        setpatientLocked(data.patientLocked);
        if (data.stateList) {
          setStateList(data.stateList);
        }
        SetFields(data);
      } else {
        if (response?.status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        } else {
          throw response.error;
        }
      }
    } catch (error) {
      ShowToast(CommonError_Msgs.LOAD_ERR, ToastMessageType.Failed);
    }
  }
  const SetFields = (data) => {

    setCCFirstEncounterDate(data.savedOneYearPreTransplantStartDate);

    setDates((prev) => {
      const updatedData = prev;
      const surveyDt = GetChartDateStr();
      if (data.birthDate) {
        updatedData.birthDt = data.birthDate;
      }
      if (surveyDt) {
        updatedData.surveyDt = surveyDt;
      }
      if (data.indexDate) {
        updatedData.indexDt = data.indexDate;

        const iDtMinus1 = AdjustDays(data.indexDate, -1);
        const iDtMinus365 = AdjustDays(data.indexDate, -Values.value365);
        const iDtPlus548 = AdjustDays(data.indexDate, Values.value548);
        if (iDtMinus1) {
          updatedData.indexMinus1Day = iDtMinus1;
        }
        if (iDtMinus365) {
          updatedData.indexMinus365Days = iDtMinus365;
        }
        if (iDtPlus548) {
          updatedData.indexPlus548Days = iDtPlus548;
        }
      }
      //18-month follow-up date
      updatedData.eighteenMonthFollowUpDt = GetEarliestDate(
        updatedData.indexPlus548Days,
        data.lastEncounterDate,
        data.deathDate
      );
      return updatedData;
    });

    setDemoDetails((prev) => {
      let state_name = prev.state_name;

      const state = data.stateList?.find((a) => a.id === data.stateId);
      if (state) {
        state_name = state.name;
      }


      let rbl_insurance = null;
      if (data.insuranceNone) {
        rbl_insurance = 1;
      } else if (data.insuranceUnk) {
        rbl_insurance = Values.value99;
      }
    

      return {
        ...prev,
        //1
        rbl_birth: data.patientBirth,
        birth_dt: data.birthDate,
        //2
        rbl_mma_diagnosis: data.mmaDiagnosis,
        mma_diagnosis_dt: data.mmaDiagnosisDate,
        //3
        rbl_gender: data.gender,
        //4
        chk_race_american: data.raceAmerican,
        chk_race_asian: data.raceAsian,
        chk_race_black: data.raceBlack,
        chk_race_hawaiian: data.raceHawaiian,
        chk_race_white: data.raceWhite,
        chk_race_oth: data.raceOth,
        rb_race_unk: data.raceUnk,
        chk_race_hispanic: data.raceHispanic,
        chk_race_middle_eastern: data.raceMiddleeastern,
        //5
        rbl_ethnicity: data.ethnicity,
        //6
        dd_state_id: data.stateId,
        state_name,
        //7
        chk_insurance_commercial: data.insuranceCommercial,
        chk_insurance_medicare: data.insuranceMedicare,
        chk_insurance_medicaid: data.insuranceMedicaid,
        chk_insurance_military: data.insuranceMilitaryInsurance,
        chk_insurance_oth: data.insuranceOth,
        txt_insurance_oth: data.insuranceOthTxt || "",
        rbl_insurance,
        //8
        rbl_mma_mut_genotype_first_allele: data.mmaMutGenotypeFirst,

        txt_mma_mut_genotype_first: data.mmaMutGenotypeFirstmutationTxt || "", 

        rbl_mma_mut_genotype_second_allele: data.mmaMutGenotypeSecond,
        txt_mma_mut_genotype_second: data.mmaMutGenotypeSecondmutationTxt || "",
        //9
        rbl_wt_assess: data.weightAssessed,
        wt_assess_dt: data.weightAssessmentDate,
        chk_wt_assess_dt_est: data.weightEstimated,
        rbl_wt_measure: data.weightMeasurement,
        txt_wt_measure_kg:
          data.weightMeasurement === Values.value2 ? data.weightMeasurementKgLbs || "" : "",
        txt_wt_measure_lbs:
          data.weightMeasurement === Values.value1 ? data.weightMeasurementKgLbs || "" : "",
        //10
        rbl_ht_assess: data.heightAssessed,
        ht_assess_dt: data.heightAssessmentDate,
        chk_ht_assess_dt_est: data.heightEstimated,
        rbl_ht_measure: data.heightMeasurement,
        txt_ht_measure_ft: data.heightFeetVal || "",
        txt_ht_measure_in: data.heightInchVal || "",
        txt_ht_measure_cm: data.heightCmVal || "",
        //11
        rbl_head_circ_assess: data.headAssessed,
        head_circ_assess_dt: data.headAssessmentDate,
        chk_head_circ_assess_dt_est: data.headEstimated,
        rbl_head_circ_measure: data.headMeasurement,
        txt_head_circ_measure_in: data.headInchVal ? data.headInchVal : "",
        txt_head_circ_measure_cm: data.headCmVal ? data.headCmVal : "",
        //12
        last_encounter_dt: data.lastEncounterDate,
        //13
        rbl_death: data.deathStatus,
        death_dt: data.deathDate,
        chk_death_dt_est: data.deathDateEstimated,
        //14
        chk_death_cause_mde: data.deathCauseMde,
        chk_death_cause_hyperammonemia: data.hyperammonemia,
        chk_death_cause_metabolic_acidosis: data.metabolicAcidosis,
        chk_death_cause_lactatemia: data.lactatemia,
        chk_death_cause_lt_lkt: data.deathCauseLtLkt,
        chk_death_cause_severe_mma_symptoms: data.deathCauseSevereMma,
        chk_death_cause_infection: data.deathCauseInfection,
        chk_death_cause_oth: data.deathCauseOth,
        txt_death_cause_oth: data.DeathCauseOthTxt || "",
        rb_death_cause_unk: data.DeathCauseUnk,
        //15
        chk_prior_comorb_diabetes_1: data.comorbiditiesPrior1Diabetes,
        chk_prior_comorb_diabetes_2: data.comorbiditiesPrior2Diabetes,
        chk_prior_comorb_osteoporosis: data.comorbiditiesPriorOsteoporosis,
        rb_prior_comorb_none: data.comorbiditiesPriorNone,
        //16
        chk_after_comorb_diabetes_1: data.comorbiditiesAfter1Diabetes,
        chk_after_comorb_diabetes_2: data.comorbiditiesAfter2Diabetes,
        chk_after_comorb_osteoporosis: data.comorbiditiesAfterOsteoporosis,
        rb_after_comorb_none: data.comorbiditiesAfterNone,
        //17
        rbl_first_center_tmt: data.firstCenterTrmt,
        first_center_tmt_dt: data.firstCenterTrmtDate,
        chk_first_center_tmt_dt_est: data.firstCenterTrmtEstimated,
        //18
        rbl_last_center_tmt: data.lastCenterTrmt,
        last_center_tmt_dt: data.lastCenterTrmtDate,
        chk_last_center_tmt_dt_est: data.lastCenterTrmtEstimated,

        //3 new
        rbl_disease_onset: data.mmaDiseaseOnset,
        disease_onset_dt: data.mmaDiseaseOnsetDate,
        chk_disease_onset_dt_est: data.mmaDiseaseOnsetDateEstimated,

        chk_mma_diagnosis_dt_est: data.mmaDiagnosisDateEstimated, 
      };
    });
  };

  const SavePage = async (validate) => {
      try {

          if (!patientLocked) {
              //Reset Errors
              setHardErrList(InitialHardErrList);
              let isValid = validate ? Validate() : true;
              if (!isValid) {
                  setShowTopErrMsg(true);
                  return false;
              }
              setShowTopErrMsg(false);


              let indexMinus365Days = AdjustDays(dates.indexDt, -Values.value365);

              let most_recent_transplant_startdt = GetMaxDate(indexMinus365Days, ccFirstEncounterDate, demoDetails.birth_dt);

              let weightMeasurementKgLbs = null;
              if (demoDetails.rbl_wt_measure === Values.value1) {
                  weightMeasurementKgLbs = demoDetails.txt_wt_measure_lbs;
              } else if (demoDetails.rbl_wt_measure === Values.value2) {
                  weightMeasurementKgLbs = demoDetails.txt_wt_measure_kg;
              }


              if (pidRef.current > 0) {
                  const payload = {
                      PatientId: pidRef.current,
                      UserId: GetLoggedInUserID(),
                      IsValidated: validate,
                      IsAdmin: IsAdmin(),
                      PatientBirth: demoDetails.rbl_birth,
                      BirthDate: demoDetails.birth_dt,
                      MmaDiagnosis: demoDetails.rbl_mma_diagnosis,
                      MmaDiagnosisDate: demoDetails.mma_diagnosis_dt,
                      MmaDiagnosisDateEstimated: demoDetails.chk_mma_diagnosis_dt_est,
                      MmaDiseaseOnset: demoDetails.rbl_disease_onset,
                      MmaDiseaseOnsetDate: demoDetails.disease_onset_dt,
                      MmaDiseaseOnsetDateEstimated: demoDetails.chk_disease_onset_dt_est,

                      Gender: demoDetails.rbl_gender,
                      RaceAmerican: demoDetails.chk_race_american,
                      RaceAsian: demoDetails.chk_race_asian,
                      RaceBlack: demoDetails.chk_race_black,
                      RaceHispanic: demoDetails.chk_race_hispanic,
                      RaceMiddleeastern: demoDetails.chk_race_middle_eastern,
                      RaceHawaiian: demoDetails.chk_race_hawaiian,
                      RaceWhite: demoDetails.chk_race_white,
                      RaceOth: demoDetails.chk_race_oth,
                      RaceUnk: demoDetails.rb_race_unk,
                      Ethnicity: demoDetails.rbl_ethnicity,
                      StateId: demoDetails.dd_state_id,
                      InsuranceCommercial: demoDetails.chk_insurance_commercial,
                      InsuranceMedicare: demoDetails.chk_insurance_medicare,
                      InsuranceMedicaid: demoDetails.chk_insurance_medicaid,
                      InsuranceMilitaryInsurance: demoDetails.chk_insurance_military,
                      InsuranceOth: demoDetails.chk_insurance_oth,
                      InsuranceOthTxt: demoDetails.txt_insurance_oth,
                      InsuranceNone: demoDetails.rbl_insurance === 1,
                      InsuranceUnk: demoDetails.rbl_insurance === Values.value99,

                      MmaMutGenotypeFirstmutationTxt:
                          demoDetails.txt_mma_mut_genotype_first,

                      MmaMutGenotypeFirst:
                          demoDetails.rbl_mma_mut_genotype_first_allele,

                      MmaMutGenotypeSecondmutationTxt:
                          demoDetails.txt_mma_mut_genotype_second,

                      MmaMutGenotypeSecond:
                          demoDetails.rbl_mma_mut_genotype_second_allele,


                      WeightAssessed: demoDetails.rbl_wt_assess,
                      WeightAssessmentDate: demoDetails.wt_assess_dt,
                      WeightEstimated: demoDetails.chk_wt_assess_dt_est,
                      WeightMeasurement: demoDetails.rbl_wt_measure,
                      WeightMeasurementKgLbs: weightMeasurementKgLbs,
                      HeightAssessed: demoDetails.rbl_ht_assess,
                      HeightAssessmentDate: demoDetails.ht_assess_dt,
                      HeightEstimated: demoDetails.chk_ht_assess_dt_est,
                      HeightMeasurement: demoDetails.rbl_ht_measure,
                      HeightFeet:
                          demoDetails.rbl_ht_measure === 1
                              ? demoDetails.txt_ht_measure_ft
                              : null,
                      HeightInch:
                          demoDetails.rbl_ht_measure === 1
                              ? demoDetails.txt_ht_measure_in
                              : null,
                      HeightCm:
                          demoDetails.rbl_ht_measure === 2
                              ? demoDetails.txt_ht_measure_cm
                              : null,
                      HeadAssessed: demoDetails.rbl_head_circ_assess,
                      HeadAssessmentDate: demoDetails.head_circ_assess_dt,
                      HeadEstimated: demoDetails.chk_head_circ_assess_dt_est,
                      HeadMeasurement: demoDetails.rbl_head_circ_measure,
                      HeadInch:
                          demoDetails.rbl_head_circ_measure === 1
                              ? demoDetails.txt_head_circ_measure_in
                              : null,
                      HeadCm:
                          demoDetails.rbl_head_circ_measure === 2
                              ? demoDetails.txt_head_circ_measure_cm
                              : null,
                      SavedOneYearPreTransplantStartDate: demoDetails.birth_dt == null || demoDetails.birth_dt === "" ? most_recent_transplant_startdt : newTransplantMaxDate,
                      BeginningFollowUpDate: demoDetails.birth_dt === null || demoDetails.birth_dt === "" ? most_recent_transplant_startdt : newBegginingFollowupDate,
                  };

                  ToggleLoader(true);
                  const response = await DemographicService.SaveData(payload);
                  ToggleLoader(false);
                  if (response.status !== HTTPResponse.OK) {
                      if (response?.status === HTTPResponse.Unauthorized) {
                          HandleSessionTimeout();
                      } else throw response.error;
                  } else {
                      if (response?.data?.isDateChanged) {
                          getConfigData();
                      }
                      ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);

                      await LoadData();
                      if (response) {
                          const { data } = response;

                          if (data) {
                              SetFields(data);
                          }
                      }
                  }
              }
          }
      return true;
    } catch (error) {
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };
  const Validate = () => {
    let isValid = true;
    //1
    let birth_empty = false;
    let birth_dt_empty = false;
    let birth_dt_invalid = false;
    //2
    let mma_diagnosis_empty = false;
    let mma_diagnosis_dt_empty = false;
    let mma_diagnosis_dt_invalid = false;
    //3
    let gender_empty = false;
    //4
    let race_empty = false;
   
    //6
    let state_empty = false;
    //7
    let insurance_commercial_empty = false;
    //8
    let mma_mut_genotype_first_empty = false;
    let mma_mut_genotype_second_empty = false;
    //9
    let wt_assess_empty = false;
    let wt_assess_dt_empty = false;
    let wt_assess_dt_invalid = false;

    let wt_measure_empty = false;
    let wt_measure_invalid = false;
    //10
    let ht_assess_empty = false;
    let ht_assess_dt_empty = false;
    let ht_assess_dt_invalid = false;

    let ht_measure_empty = false;
    let ht_measure_invalid = false;
    //11
    let head_circ_assess_empty = false;
    let head_circ_assess_dt_empty = false;
    let head_circ_assess_dt_invalid = false;

    let head_circ_measure_empty = false;
    let head_circ_measure_invalid = false;


    //3
    let disease_onset_empty = false;
    let disease_onset_dt_empty = false;
    let disease_onset_dt_invalid = false;

    //1
    if (demoDetails.rbl_birth === null) {
      birth_empty = true;
    } else {
      if (demoDetails.rbl_birth === 1) {
        if (demoDetails.birth_dt == null) {
          birth_dt_empty = true;
        }
       
        else if (IsDateAfter(demoDetails.birth_dt, dates.indexDt)) { //SYJ - 28/03/2025- Changes for -> https://edotpulse.com/EditActionItem/AG-M-158
          birth_dt_invalid = true;
        }
      }
    }
    //2
    if (demoDetails.rbl_mma_diagnosis === null) {
      mma_diagnosis_empty = true;
    } else {
      if (demoDetails.rbl_mma_diagnosis === 1) {
        if (demoDetails.mma_diagnosis_dt === null) {
          mma_diagnosis_dt_empty = true;
        } else if (
          !IsDateValid(
            demoDetails.mma_diagnosis_dt,
            demoDetails.birth_dt,
            dates.indexDt
          )
        ) {
          mma_diagnosis_dt_invalid = true;
        }
      }
    }
    if (demoDetails.rbl_gender === null) {
      gender_empty = true;
    }
    //4
    if (
      !demoDetails.chk_race_american &&
      !demoDetails.chk_race_asian &&
      !demoDetails.chk_race_black &&
      !demoDetails.chk_race_hawaiian &&
      !demoDetails.chk_race_white &&
      !demoDetails.chk_race_oth &&
      !demoDetails.rb_race_unk &&
      !demoDetails.chk_race_hispanic &&
      !demoDetails.chk_race_middle_eastern
    ) {
      race_empty = true;
    }

    if (demoDetails.dd_state_id === null) {
      state_empty = true;
    }
    //7
    if (
      (!demoDetails.chk_insurance_commercial &&
        !demoDetails.chk_insurance_medicare &&
        !demoDetails.chk_insurance_medicaid &&
        !demoDetails.chk_insurance_military &&
        !demoDetails.chk_insurance_oth &&
        demoDetails.rbl_insurance === null) ||
      (demoDetails.chk_insurance_oth && demoDetails.txt_insurance_oth === "")
    ) {
      insurance_commercial_empty = true;
    }
    //8
    if (
      demoDetails.rbl_mma_mut_genotype_first_allele === null ||
      (demoDetails.rbl_mma_mut_genotype_first_allele === 1 &&
        demoDetails.txt_mma_mut_genotype_first === "")
    ) {
      mma_mut_genotype_first_empty = true;
    }

    if (
      demoDetails.rbl_mma_mut_genotype_second_allele == null ||
      (demoDetails.rbl_mma_mut_genotype_second_allele === 1 &&
        demoDetails.txt_mma_mut_genotype_second === "")
    ) {
      mma_mut_genotype_second_empty = true;
    }
    //9
    if (demoDetails.rbl_wt_assess == null) {
      wt_assess_empty = true;
    } else {
      if (demoDetails.rbl_wt_assess === 1) {
        if (demoDetails.wt_assess_dt == null) {
          wt_assess_dt_empty = true;
        } else if (
          !IsDateValid(
            demoDetails.wt_assess_dt,
            dates.indexMinus365Days,
            dates.indexMinus1Day
          )
        ) {
          wt_assess_dt_invalid = true;
        }
      }
    }
    if (demoDetails.rbl_wt_assess !== 2) {
      if (demoDetails.rbl_wt_measure == null) {
        wt_measure_empty = true;
      } else {
        if (
          demoDetails.rbl_wt_measure === 2 &&
          (demoDetails.txt_wt_measure_kg === "" ||
            !ValueInRange(demoDetails.txt_wt_measure_kg, 1, 630))
        ) {
          wt_measure_invalid = true;
        } else if (
          demoDetails.rbl_wt_measure === 1 &&
          (demoDetails.txt_wt_measure_lbs === "" ||
            !ValueInRange(demoDetails.txt_wt_measure_lbs, 1, 1400))
        ) {
          wt_measure_invalid = true;
        }
      }
    }
    //10
    if (demoDetails.rbl_ht_assess == null) {
      ht_assess_empty = true;
    } else {
      if (demoDetails.rbl_ht_assess === 1) {
        if (demoDetails.ht_assess_dt == null) {
          ht_assess_dt_empty = true;
        } else if (
          !IsDateValid(
            demoDetails.ht_assess_dt,
            dates.indexMinus365Days,
            dates.indexMinus1Day
          )
        ) {
          ht_assess_dt_invalid = true;
        }
      }
    }
    if (demoDetails.rbl_ht_assess !== 3) {
      if (demoDetails.rbl_ht_measure == null) {
        ht_measure_empty = true;
      } else {
        if (
          demoDetails.rbl_ht_measure === 1 &&
          (demoDetails.txt_ht_measure_ft === "" ||
            demoDetails.txt_ht_measure_in === "" ||
            !ValueInRange(demoDetails.txt_ht_measure_ft, 0, 9) ||
            !ValueInRange(demoDetails.txt_ht_measure_in, 0, 12))
        ) {
          ht_measure_invalid = true;
        } else if (
          demoDetails.rbl_ht_measure === 2 &&
          (demoDetails.txt_ht_measure_cm === "" ||
            !ValueInRange(demoDetails.txt_ht_measure_cm, 1, 300))
        ) {
          ht_measure_invalid = true;
        }
      }
    }
    //11
    if (demoDetails.rbl_head_circ_assess == null) {
      head_circ_assess_empty = true;
    } else {
      if (demoDetails.rbl_head_circ_assess === 1) {
        if (demoDetails.head_circ_assess_dt == null) {
          head_circ_assess_dt_empty = true;
        } else if (
          !IsDateValid(
            demoDetails.head_circ_assess_dt,
            dates.indexMinus365Days,
            dates.indexMinus1Day
          )
        ) {
          head_circ_assess_dt_invalid = true;
        }
      }
    }
    if (demoDetails.rbl_head_circ_assess !== 3) {
      if (demoDetails.rbl_head_circ_measure == null) {
        head_circ_measure_empty = true;
      } else {
        if (
          demoDetails.rbl_head_circ_measure === 1 &&
          (demoDetails.txt_head_circ_measure_in === "" ||
            !ValueInRange(demoDetails.txt_head_circ_measure_in, 1, 36))
        ) {
          head_circ_measure_invalid = true;
        } else if (
          demoDetails.rbl_head_circ_measure === 2 &&
          (demoDetails.txt_head_circ_measure_cm === "" ||
            !ValueInRange(demoDetails.txt_head_circ_measure_cm, 1, 100))
        ) {
          head_circ_measure_invalid = true;
        }
      }
    }


    //3
    if (demoDetails.rbl_disease_onset == null) {
      disease_onset_empty = true;
    } else {
      if (demoDetails.rbl_disease_onset === 2) {
        if (demoDetails.disease_onset_dt == null) {
          disease_onset_dt_empty = true;
        } else if (
          !DateValid(demoDetails.birth_dt, demoDetails.disease_onset_dt)
        ) {
          disease_onset_dt_invalid = true;
        }
      }
    }

    setHardErrList((prev) => ({
      ...prev,
      birth_empty,
      birth_dt_empty,
      birth_dt_invalid,
      mma_diagnosis_empty,
      mma_diagnosis_dt_empty,
      mma_diagnosis_dt_invalid,
      gender_empty,
      race_empty,
      state_empty,
      insurance_commercial_empty,
      mma_mut_genotype_first_empty,
      mma_mut_genotype_second_empty,
      wt_assess_empty,
      wt_assess_dt_empty,
      wt_assess_dt_invalid,
      wt_measure_empty,
      wt_measure_invalid,
      ht_assess_empty,
      ht_assess_dt_empty,
      ht_assess_dt_invalid,
      ht_measure_empty,
      ht_measure_invalid,
      head_circ_assess_empty,
      head_circ_assess_dt_empty,
      head_circ_assess_dt_invalid,

      disease_onset_empty,
      disease_onset_dt_empty,
      disease_onset_dt_invalid,

      head_circ_measure_empty,
      head_circ_measure_invalid
    }));

    if (
      birth_empty ||
      birth_dt_empty ||
      birth_dt_invalid ||
      mma_diagnosis_empty ||
      mma_diagnosis_dt_empty ||
      mma_diagnosis_dt_invalid ||
      gender_empty ||
      race_empty ||
      state_empty ||
      insurance_commercial_empty ||
      mma_mut_genotype_first_empty ||
      mma_mut_genotype_second_empty ||
      wt_assess_empty ||
      wt_assess_dt_empty ||
      wt_assess_dt_invalid ||
      wt_measure_empty ||
      wt_measure_invalid ||
      ht_assess_empty ||
      ht_assess_dt_empty ||
      ht_assess_dt_invalid ||
      ht_measure_empty ||
      ht_measure_invalid ||
      head_circ_assess_empty ||
      head_circ_assess_dt_empty ||
      head_circ_assess_dt_invalid ||
      head_circ_measure_empty ||
      head_circ_measure_invalid ||
      disease_onset_empty ||
      disease_onset_dt_empty ||
      disease_onset_dt_invalid
    ) {
      isValid = false;
    }
    return isValid;
  };
  const HandleFieldChange = (e) => {

    const { name, value } = e.target;
    switch (name) {
      case "rbl_birth":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            birth_dt: null,
          }));
          setDates((prev) => ({
            ...prev,
            birthDt: null,
          }));
          setHardErrList((prev) => ({
            ...prev,
            birth_empty: false,
            birth_dt_empty: false,
            birth_dt_invalid: false,
          }));
        }
        break;
      case "rbl_mma_diagnosis":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            mma_diagnosis_dt: null,
            chk_mma_diagnosis_dt_est:false
          }));
          setHardErrList((prev) => ({
            ...prev,
            mma_diagnosis_empty: false,
            mma_diagnosis_dt_empty: false,
            mma_diagnosis_dt_invalid: false,
            
          }));
        }
        break;

        case "chk_mma_diagnosis_dt_est":
          {
            setDemoDetails((prev) => ({
              ...prev,
              [name]: !prev[name],
              rbl_mma_diagnosis: 1,
            }));
  
            setHardErrList((prev) => ({
              ...prev,
              mma_diagnosis_empty: false,
              mma_diagnosis_dt_empty: false,
              mma_diagnosis_dt_invalid: false,
          }));
        }
        break;
      case "rbl_gender":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: Number(value),
          }));
          setHardErrList((prev) => ({
            ...prev,
            gender_empty: false,
          }));
        }
        break;
      case "chk_race_american":
      case "chk_race_asian":
      case "chk_race_black":
      case "chk_race_hawaiian":
      case "chk_race_white":
      case "chk_race_hispanic":
      case "chk_race_middle_eastern":
      case "chk_race_oth":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            rb_race_unk: false,
          }));
          setHardErrList((prev) => ({
            ...prev,
            race_empty: false,
          }));
        }
        break;
      case "rb_race_unk":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            chk_race_american: false,
            chk_race_asian: false,
            chk_race_black: false,
            chk_race_hawaiian: false,
            chk_race_white: false,
            chk_race_hispanic: false,
            chk_race_middle_eastern: false,
            chk_race_oth: false,
          }));
          setHardErrList((prev) => ({
            ...prev,
            race_empty: false,
          }));
        }
        break;

      case "rbl_insurance":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            chk_insurance_commercial: false,
            chk_insurance_medicare: false,
            chk_insurance_medicaid: false,
            chk_insurance_military: false,
            chk_insurance_oth: false,
            txt_insurance_oth: "",
          }));
          setHardErrList((prev) => ({
            ...prev,
            insurance_commercial_empty: false,
          }));
        }
        break;
      case "chk_insurance_commercial":
      case "chk_insurance_medicare":
      case "chk_insurance_medicaid":
      case "chk_insurance_military":
      case "chk_insurance_oth":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            rbl_insurance: null,
            txt_insurance_oth:
              name === "chk_insurance_oth" ? "" : prev.txt_insurance_oth,
          }));
          setHardErrList((prev) => ({
            ...prev,
            insurance_commercial_empty: false,
          }));
        }
        break;
      case "txt_insurance_oth":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: value,
            rbl_insurance: null,
            chk_insurance_oth: true,
          }));
          setHardErrList((prev) => ({
            ...prev,
            insurance_commercial_empty: false,
          }));
        }
        break;
      case "rbl_mma_mut_genotype_first_allele":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            txt_mma_mut_genotype_first: "",
          }));
          setHardErrList((prev) => ({
            ...prev,
            mma_mut_genotype_first_empty: false,
          }));
        }
        break;
      case "txt_mma_mut_genotype_first":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: value,
            rbl_mma_mut_genotype_first_allele: 1,
          }));
          setHardErrList((prev) => ({
            ...prev,
            mma_mut_genotype_first_empty: false,
          }));
        }
        break;

      case "rbl_mma_mut_genotype_second_allele":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            txt_mma_mut_genotype_second: "",
          }));
          setHardErrList((prev) => ({
            ...prev,
            mma_mut_genotype_second_empty: false,
          }));
        }
        break;
      case "txt_mma_mut_genotype_second":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: value,
            rbl_mma_mut_genotype_second_allele: 1,
          }));
          setHardErrList((prev) => ({
            ...prev,
            mma_mut_genotype_second_empty: false,
          }));
        }
        break;

      case "rbl_wt_assess":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            wt_assess_dt: null,
            chk_wt_assess_dt_est: false,

            txt_wt_measure_kg: Number(value) === 2 ? null : prev.txt_wt_measure_kg,
            txt_wt_measure_lbs: Number(value) === 2 ? null : prev.txt_wt_measure_lbs,

            rbl_wt_measure: Number(value) === 2 ? null : prev.rbl_wt_measure,

          }));
          setHardErrList((prev) => {
            const updateData = {
              ...prev,
              wt_assess_empty: false,
              wt_assess_dt_empty: false,
              wt_assess_dt_invalid: false,
            };
            //reset C
            if (Number(value) === 2) {
              updateData.wt_measure_empty = false;
              updateData.wt_measure_invalid = false;
            }
            return updateData;
          });
        }
        break;
      case "chk_wt_assess_dt_est":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            rbl_wt_assess: 1,
          }));
        }
        break;
      case "rbl_wt_measure":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            txt_wt_measure_kg: "",
            txt_wt_measure_lbs: "",
          }));
          setHardErrList((prev) => ({
            ...prev,
            wt_measure_empty: false,
            wt_measure_invalid: false,
          }));
        }
        break;
      case "txt_wt_measure_kg":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: AllowOnlyNumbersWithTwoDecimals(value) ? value : prev[name],
            rbl_wt_measure: 2,
            txt_wt_measure_lbs: "",
          }));
          setHardErrList((prev) => ({
            ...prev,
            wt_measure_empty: false,
            wt_measure_invalid: false,
          }));
        }
        break;
      case "txt_wt_measure_lbs":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: AllowOnlyNumbersWithTwoDecimals(value) ? value : prev[name],
            rbl_wt_measure: 1,
            txt_wt_measure_kg: "",
          }));
          setHardErrList((prev) => ({
            ...prev,
            wt_measure_empty: false,
            wt_measure_invalid: false,
          }));
        }
        break;
      case "rbl_ht_assess":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            ht_assess_dt: null,
            chk_ht_assess_dt_est: false,

            txt_ht_measure_ft: Number(value) === 3 ? null : prev.txt_ht_measure_ft,
            txt_ht_measure_in: Number(value) === 3 ? null : prev.txt_ht_measure_in,
            txt_ht_measure_cm: Number(value) === 3 ? "" : prev.txt_ht_measure_cm,
            rbl_ht_measure: Number(value) === 3 ? null : prev.rbl_ht_measure,
          }));
          setHardErrList((prev) => {
            const updateData = {
              ...prev,
              ht_assess_empty: false,
              ht_assess_dt_empty: false,
              ht_assess_dt_invalid: false,
            };
            //reset C
            if (Number(value) === 3) {
              updateData.ht_measure_empty = false;
              updateData.ht_measure_invalid = false;
            }
            return updateData;
          });
        }
        break;
      case "chk_ht_assess_dt_est":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            rbl_ht_assess: 1,
          }));
        }
        break;
      case "rbl_ht_measure":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            txt_ht_measure_ft: "",
            txt_ht_measure_in: "",
            txt_ht_measure_cm: "",
          }));
          setHardErrList((prev) => ({
            ...prev,
            ht_measure_empty: false,
            ht_measure_invalid: false,
          }));
        }
        break;
      case "txt_ht_measure_ft":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: AllowOnlyIntegers(value) ? value : prev[name],
            rbl_ht_measure: 1,
            txt_ht_measure_cm: "",
          }));
          setHardErrList((prev) => ({
            ...prev,
            ht_measure_empty: false,
            ht_measure_invalid: false,
          }));
        }
        break;
      case "txt_ht_measure_in":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: AllowOnlyNumbersWithTwoDecimals(value) ? value : prev[name],
            rbl_ht_measure: 1,
            txt_ht_measure_cm: "",
          }));
          ;
          setHardErrList((prev) => ({
            ...prev,
            ht_measure_empty: false,
            ht_measure_invalid: false,
          }));
        }
        break;
      case "txt_ht_measure_cm":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: AllowOnlyNumbersWithTwoDecimals(value) ? value : prev[name],
            rbl_ht_measure: 2,
            txt_ht_measure_ft: "",
            txt_ht_measure_in: "",
          }));
          setHardErrList((prev) => ({
            ...prev,
            ht_measure_empty: false,
            ht_measure_invalid: false,
          }));
        }
        break;
      case "rbl_head_circ_assess":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            head_circ_assess_dt: null,
            chk_head_circ_assess_dt_est: false,
            rbl_head_circ_measure: Number(value) === 3 ? null : prev.rbl_head_circ_measure,
            txt_head_circ_measure_in: Number(value) === 3 ? "" : prev.txt_head_circ_measure_in,
            txt_head_circ_measure_cm: Number(value) === 3 ? "" : prev.txt_head_circ_measure_cm,
          }));
          setHardErrList((prev) => {
            const updateData = {
              ...prev,
              head_circ_assess_empty: false,
              head_circ_assess_dt_empty: false,
              head_circ_assess_dt_invalid: false,
            };
            //reset C
            if (Number(value) === 3) {

              updateData.head_circ_measure_empty = false;
              updateData.head_circ_measure_invalid = false;
            }
            return updateData;
          });
        }
        break;
      case "chk_head_circ_assess_dt_est":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            rbl_head_circ_assess: 1,
          }));
        }
        break;
      case "rbl_head_circ_measure":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            txt_head_circ_measure_in: "",
            txt_head_circ_measure_cm: "",
          }));
          setHardErrList((prev) => ({
            ...prev,
            head_circ_measure_empty: false,
            head_circ_measure_invalid: false,
          }));
        }
        break;
      case "txt_head_circ_measure_in":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: AllowOnlyNumbersWithTwoDecimals(value) ? value : prev[name],
            rbl_head_circ_measure: 1,
            txt_head_circ_measure_cm: "",
          }));
          setHardErrList((prev) => ({
            ...prev,
            head_circ_measure_empty: false,
            head_circ_measure_invalid: false,
          }));
        }
        break;
      case "txt_head_circ_measure_cm":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: AllowOnlyNumbersWithTwoDecimals(value) ? value : prev[name],
            rbl_head_circ_measure: 2,
            txt_head_circ_measure_in: "",
          }));
          setHardErrList((prev) => ({
            ...prev,
            head_circ_measure_empty: false,
            head_circ_measure_invalid: false,
          }));
        }
        break;

      //Q3
      case "rbl_disease_onset":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            chk_disease_onset_dt_est: false,
            disease_onset_dt: null
          }));

          setHardErrList((prev) => ({
            ...prev,
            disease_onset_empty: false,
            disease_onset_dt_empty: false,
            disease_onset_dt_invalid: false,
          }));
        }
        break;
      case "chk_disease_onset_dt_est":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            rbl_disease_onset: 2,
          }));

          setHardErrList((prev) => ({
            ...prev,
            disease_onset_empty: false,
            disease_onset_dt_empty: false,
            disease_onset_dt_invalid: false,
          }));
        }
        break;

      default:
        break;
    }
  };
  const HandleDateChange = (name, date) => {
    switch (name) {
      case "birth_dt":
        {
          setDemoDetails((prev) => {
            if (!IsDateInvalid(date)) {
              setDates((prev) => ({
                ...prev,
                birthDt: date,
              }));
            }
            return {
              ...prev,
              [name]: date,
              rbl_birth: 1,
            };
          });
          setHardErrList((prev) => ({
            ...prev,
            birth_empty: false,
            birth_dt_empty: false,
            birth_dt_invalid: false,
          }));

          let indexMinus365Days = AdjustDays(dates.indexDt, -Values.value365);

          let most_recent_transplant_startdt = GetMaxDate(indexMinus365Days, ccFirstEncounterDate, date);
          setnewTransplantMaxDate(most_recent_transplant_startdt);
          setnewBegginingFollowupDate(most_recent_transplant_startdt);
        
        }
        break;
      case "mma_diagnosis_dt":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: date,
            rbl_mma_diagnosis: 1,
          }));
          setHardErrList((prev) => ({
            ...prev,
            mma_diagnosis_empty: false,
            mma_diagnosis_dt_empty: false,
            mma_diagnosis_dt_invalid: false,
          }));
        }
        break;
      case "wt_assess_dt":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: date,
            rbl_wt_assess: 1,
          }));
          setHardErrList((prev) => ({
            ...prev,
            wt_assess_empty: false,
            wt_assess_dt_empty: false,
            wt_assess_dt_invalid: false,
          }));
        }
        break;
      case "ht_assess_dt":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: date,
            rbl_ht_assess: 1,
          }));
          setHardErrList((prev) => ({
            ...prev,
            ht_assess_empty: false,
            ht_assess_dt_empty: false,
            ht_assess_dt_invalid: false,
          }));
        }
        break;
      case "head_circ_assess_dt":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: date,
            rbl_head_circ_assess: 1,
          }));
          setHardErrList((prev) => ({
            ...prev,
            head_circ_assess_empty: false,
            head_circ_assess_dt_empty: false,
            head_circ_assess_dt_invalid: false,
          }));
        }
        break;
      //3
      case "disease_onset_dt":
        {
          setDemoDetails((prev) => ({
            ...prev,
            [name]: date,
            rbl_disease_onset: 2,
          }));
          setHardErrList((prev) => ({
            ...prev,
            disease_onset_empty: false,
            disease_onset_dt_empty: false,
            disease_onset_dt_invalid: false,
          }));
        }
        break;
      default:
        break;
    }
  };
  const HandleStateChange = (stateId, state_name) => {
    setDemoDetails((prev) => ({
      ...prev,
      dd_state_id: stateId,
      state_name,
    }));
    setHardErrList((prev) => ({
      ...prev,
      state_empty: false,
    }));
  };


  useEffect(() => {
    applySidebarState(isSideMenuActive);
  }, [isSideMenuActive]);
  const getConfigData=async()=>{
    const prevValue=GetLocalStorageData("loadConfigBirthDate");
    AddLocalStorageData("loadConfigBirthDate", !prevValue);
    
      const ShowAlertBox = async () => {
         await ShowActionPopUp(
          "Alert",
          CommonError_Msgs.DateChangeAlert,
          "Ok",
          true
        );
      };
      ShowAlertBox();
    
  }
  return (
    <>
    
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
          </div>
        </div>
      </section>

      <section className="main-survey-section main-survey-button">
        <div >
          <SideBarMenu activePageId={SideMenuItems.Demographics} isFromDemo={true}/>
          <>
            <button className={isSideMenuActive ? "openbtn" : "openbtn active"}
              onClick={() => toggleSidebar(isSideMenuActive, setisSideMenuActive)}
            >
              <i
                id="arrowNavigation"
                className="fa fa-arrow-left"
                aria-hidden="true"
              ></i>
            </button>
          </>
          <div className=" col-pad-left eligibiltylocked" id="main">
            <div className="survey-section-content" id="contentsec">
              <div className="survey-section-content-header">
                <h4>PATIENT DEMOGRAPHICS</h4>
              </div>
              {showTopErrMsg && (
                <div className="clean-error ">
                  <ErrorField
                    show={showTopErrMsg}
                    message={CommonError_Msgs.Hard_Empty}
                  />
                </div>
              )}
              {/* <summary>
              date: 13-12-2024
              Name: ST
              description: Demographics Design
              <summary> */}
              <div className="survey-question-section" disabled={patientLocked}>
                <div className="survey-question-content survey-content-box">
                  <div className="question-answer grid-overflow">

                    {/* mainContent */}
                    <table
                      cellPadding="0"
                      cellSpacing="0"
                      width="100%"
                      border="1"
                      className="borderTable"
                    >
                      {/* Q1. */}
                      <tr>
                        <td className="containertd">
                          <div className="question question-weight">
                            <span>Q1.</span>
                            <span className="quest-text-pad">
                              Date of birth
                            </span>
                          </div>
                        </td>
                        <td className="containertd">
                          <div className="">
                            <div className="option-without-input">
                              <input
                                type="radio"
                                id="birth_1"
                                name="rbl_birth"
                                value={1}
                                checked={demoDetails.rbl_birth === Values.value1}
                                onChange={HandleFieldChange}
                              />
                              <span style={{ marginLeft: "15px" }}>
                                <DateControl
                                  ctrlId={"birth_dt"}
                                  HandleDateChange={HandleDateChange}
                                  date={demoDetails.birth_dt}
                                />
                              </span>
                            </div>
                            <div className="option-without-input">
                              <label>
                                <input
                                  type="radio"
                                  id="birth_99"
                                  name="rbl_birth"
                                  value={99}
                                  checked={
                                    demoDetails.rbl_birth ===
                                    Values.value99
                                  }
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Date unknown
                                </span>
                              </label>
                            </div>
                          </div>
                          <ErrorField
                            show={hardErrList.birth_empty}
                            message={CommonError_Msgs.Msg1}
                          />
                          <ErrorField
                            show={
                              hardErrList.birth_dt_empty ||
                              hardErrList.birth_dt_invalid
                            }
                            message={CommonError_Msgs.Msg2}
                          />
                        </td>
                      </tr>

                      {/* Q2. */}
                      <tr>
                        <td className="containertd">
                          <div className="question question-weight">
                            <span>Q2.</span>
                            <span className="quest-text-pad">
                              Date of initial MMA diagnosis
                              <br />
                              <br />
                              <p>
                                <b>Note:</b> the date of diagnosis should
                                be on or after the date of birth (
                                <span className="indigo-text">
                                  {dates.birthDt || birthDtInit}
                                </span>
                                ) and on or before the index date (
                                <span className="indigo-text">
                                  {dates.indexDt}
                                </span>
                                ).
                              </p>
                            </span>
                          </div>
                        </td>
                        <td className="containertd">
                          <div>
                            <div className="option-without-input">
                              <input
                                type="radio"
                                id="mma_diagnosis_1"
                                name="rbl_mma_diagnosis"
                                value={1}
                                checked={
                                  demoDetails.rbl_mma_diagnosis === Values.value1
                                }
                                onChange={HandleFieldChange}
                              />
                              <span style={{ marginLeft: "15px" }}>
                                <DateControl
                                  ctrlId={"mma_diagnosis_dt"}
                                  HandleDateChange={HandleDateChange}
                                  date={demoDetails.mma_diagnosis_dt}
                                />
                              </span>
                            </div>


                            <div className="estimated-date-padding text-margin">
                              <label>
                                <input
                                  type="checkbox"
                                  id="chk_mma_diagnosis_dt_est"
                                  name="chk_mma_diagnosis_dt_est"
                                  checked={
                                    demoDetails.chk_mma_diagnosis_dt_est
                                  }
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Estimated date
                                </span>
                              </label>
                            </div>


                            <div className="option-without-input">
                              <label>
                                <input
                                  type="radio"
                                  id="mma_diagnosis_99"
                                  name="rbl_mma_diagnosis"
                                  value={99}
                                  checked={
                                    demoDetails.rbl_mma_diagnosis ===
                                    Values.value99
                                  }
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Date unknown
                                </span>
                              </label>
                            </div>
                          </div>
                          <ErrorField
                            show={hardErrList.mma_diagnosis_empty}
                            message={CommonError_Msgs.Msg1}
                          />
                          <ErrorField
                            show={
                              hardErrList.mma_diagnosis_dt_empty ||
                              hardErrList.mma_diagnosis_dt_invalid
                            }
                            message={CommonError_Msgs.Msg2}
                          />
                        </td>
                      </tr>

                      {/* Q3 */}

                      <tr>
                        <td
                          className="containertd"
                          style={{
                            borderBottom: "0",
                            borderLeft: "0",
                          }}
                        >
                          <div className="question question-weight">
                            <span>Q3.</span>
                            <span className="quest-text-pad"> Date of MMA disease onset
                              <br></br>
                              <br></br>
                              <p>
                                <b>Note:</b> this includes the earliest signs,
                                symptoms, complications, or other clinical
                                manifestations of disease either before or
                                after the initial MMA diagnosis date
                              </p>
                            </span>
                          </div>
                        </td>
                        <td
                          className="containertd"
                          style={{
                            borderBottom: "0",
                          }}
                        >
                          <>
                            <div>
                              <label>
                                <input
                                  type="radio"
                                  id="disease_onset_1"
                                  name="rbl_disease_onset"
                                  value={1}
                                  checked={
                                    demoDetails.rbl_disease_onset ===
                                    Values.value1
                                  }
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Same date as initial MMA diagnosis
                                </span>
                              </label>
                            </div>

                            <div>
                              <label>
                                <input
                                  type="radio"
                                  id="disease_onset_2"
                                  name="rbl_disease_onset"
                                  value={2}
                                  checked={
                                    demoDetails.rbl_disease_onset ===
                                    Values.value2
                                  }
                                  onChange={HandleFieldChange}
                                />
                                <span className="date-field-padding-left">
                                  <DateControl
                                    ctrlId={"disease_onset_dt"}
                                    HandleDateChange={HandleDateChange}
                                    date={demoDetails.disease_onset_dt}
                                  />
                                </span>
                              </label>
                            </div>
                            <div className="estimated-date-padding text-margin">
                              <label>
                                <input
                                  type="checkbox"
                                  id="chk_disease_onset_dt_est"
                                  name="chk_disease_onset_dt_est"
                                  checked={
                                    demoDetails.chk_disease_onset_dt_est
                                  }
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Estimated date
                                </span>
                              </label>
                            </div>
             
                            <div>
                              <label>
                                <input
                                  type="radio"
                                  id="rbl_disease_onset_99"
                                  name="rbl_disease_onset"
                                  value={99}
                                  checked={
                                    demoDetails.rbl_disease_onset ===
                                    Values.value99
                                  }
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Date Unknown
                                </span>
                              </label>
                            </div>
                          </>
                          <ErrorField
                            show={hardErrList.disease_onset_empty}
                            message={CommonError_Msgs.Msg1}
                          />
                          <ErrorField
                            show={
                              hardErrList.disease_onset_dt_empty ||
                              hardErrList.disease_onset_dt_invalid
                            }
                            message={CommonError_Msgs.Msg2}
                          />
                        </td>
                      </tr>

                      {/* Q4. */}
                      <tr>
                        <td className="containertd">
                          <div className="question question-weight">
                            <span>Q4.</span>
                            <span className="quest-text-pad">
                              Patient sex
                            </span>
                          </div>
                        </td>
                        <td className="containertd">
                          <div className="">
                            <div className="option-without-input">
                              <label>
                                <input
                                  type="radio"
                                  id="gender_1"
                                  name="rbl_gender"
                                  value={1}
                                  checked={demoDetails.rbl_gender === Values.value1}
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Male
                                </span>
                              </label>
                            </div>
                            <div className="option-without-input">
                              <label>
                                <input
                                  type="radio"
                                  id="gender_2"
                                  name="rbl_gender"
                                  value={2}
                                  checked={demoDetails.rbl_gender === 2}
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Female
                                </span>
                              </label>
                            </div>
                            <div className="option-without-input">
                              <label>
                                <input
                                  type="radio"
                                  id="gender_3"
                                  name="rbl_gender"
                                  value={3}
                                  checked={demoDetails.rbl_gender === 3}
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Intersex
                                </span>
                              </label>
                            </div>
                            <div className="option-without-input">
                              <label>
                                <input
                                  type="radio"
                                  id="gender_4"
                                  name="rbl_gender"
                                  value={4}
                                  checked={demoDetails.rbl_gender === 4}
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Unknown
                                </span>
                              </label>
                            </div>
                          </div>
                          <ErrorField
                            show={hardErrList.gender_empty}
                            message={CommonError_Msgs.Msg1}
                          />
                        </td>
                      </tr>

                      {/* Q5. */}
                      <tr>
                        <td className="containertd">
                          <div className="question question-weight">
                            <span>Q5.</span>
                            <span className="quest-text-pad">
                              Patient race/ethnicity. <i>Select all that apply.</i>
                            </span>
                          </div>
                        </td>
                        <td className="containertd">
                          <div className="">
                            <div className="option-without-input">
                              <label>
                                <input
                                  type="checkbox"
                                  id="race_1"
                                  name="chk_race_american"
                                  checked={demoDetails.chk_race_american}
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  American Indian or Alaska Native
                                </span>
                              </label>
                            </div>
                            <div className="option-without-input">
                              <label>
                                <input
                                  type="checkbox"
                                  id="race_2"
                                  name="chk_race_asian"
                                  checked={demoDetails.chk_race_asian}
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Asian
                                </span>
                              </label>
                            </div>
                            <div className="option-without-input">
                              <label>
                                <input
                                  type="checkbox"
                                  id="race_3"
                                  name="chk_race_black"
                                  checked={demoDetails.chk_race_black}
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Black or African American
                                </span>
                              </label>
                            </div>

                            <div className="option-without-input">
                              <label>
                                <input
                                  type="checkbox"
                                  id="race_4"
                                  name="chk_race_hispanic"
                                  checked={demoDetails.chk_race_hispanic}
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Hispanic or Latino
                                </span>
                              </label>
                            </div>

                            <div className="option-without-input">
                              <label>
                                <input
                                  type="checkbox"
                                  id="race_5"
                                  name="chk_race_middle_eastern"
                                  checked={
                                    demoDetails.chk_race_middle_eastern
                                  }
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Middle Eastern or North African
                                </span>
                              </label>
                            </div>

                            <div className="option-without-input">
                              <label>
                                <input
                                  type="checkbox"
                                  id="race_6"
                                  name="chk_race_hawaiian"
                                  checked={demoDetails.chk_race_hawaiian}
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Native Hawaiian or Other Pacific
                                  Islander
                                </span>
                              </label>
                            </div>
                            <div className="option-without-input">
                              <label>
                                <input
                                  type="checkbox"
                                  id="race_7"
                                  name="chk_race_white"
                                  checked={demoDetails.chk_race_white}
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  White
                                </span>
                              </label>
                            </div>
                            <div className="option-without-input">
                              <label>
                                <input
                                  type="checkbox"
                                  id="race_8"
                                  name="chk_race_oth"
                                  checked={demoDetails.chk_race_oth}
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Other
                                </span>
                              </label>
                            </div>
                            <div className="option-without-input">
                              <label>
                                <input
                                  type="radio"
                                  id="race_unk"
                                  name="rb_race_unk"
                                  checked={demoDetails.rb_race_unk}
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Unknown
                                </span>
                              </label>
                            </div>
                          </div>
                          <ErrorField
                            show={hardErrList.race_empty}
                            message={CommonError_Msgs.Msg1}
                          />
                        </td>
                      </tr>

                      {/* Q6. */}
                      <tr>
                        <td className="containertd">
                          <div className="question question-weight">
                            <span>Q6.</span>
                            <span className="quest-text-pad">
                              State of residence at index date (
                              <span className="indigo-text">
                                {dates.indexDt}
                              </span>
                              )
                            </span>
                          </div>
                        </td>
                        <td className="containertd">
                          <div className="">
                            <div className="option-without-input">
                              <label>
                             
                                <span className="radio-text-padding leftPad8">
                                  <Dropdown className="custom-dropdown-caret">
                                    <Dropdown.Toggle
                                      variant=""
                                      id="dropdown-basic"
                                      className="w110 epcoritamab-custom-dropdown-button"
                                      style={{ width: '180px' }}
                                    >
                                      {demoDetails.state_name}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="w110 Demographic-custom-dropdown-menu" style={{ width: '100%' }}>
                                      {stateList.map((s) => (
                                        <Dropdown.Item
                                          as="button"
                                          name="pt_state"
                                          key={s.id}
                                          value={s.name}
                                          className={`custom-dropdown-item ${s.name ===
                                            demoDetails.state_name &&
                                            "custom-dropdown-item-selected"
                                            }`}
                                          onClick={() =>
                                            HandleStateChange(
                                              s.id,
                                              s.name
                                            )
                                          }
                                        >
                                          {s.name}
                                        </Dropdown.Item>
                                      ))}
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </span>
                              </label>
                            </div>
                          </div>
                          <ErrorField
                            show={hardErrList.state_empty}
                            message={CommonError_Msgs.Msg1}
                          />
                        </td>
                      </tr>

                      {/* Q7. */}
                      <tr>
                        <td className="containertd">
                          <div className="question question-weight">
                            <span>Q7.</span>
                            <span className="quest-text-pad">
                              Insurance type at index date (
                              <span className="indigo-text">
                                {dates.indexDt}
                              </span>
                              ). <i>Select all that apply.</i>
                            </span>
                          </div>
                        </td>
                        <td className="containertd">
                          <div className="">
                            <div className="option-without-input">
                              <label>
                                <input
                                  type="checkbox"
                                  id="insurance_1"
                                  name="chk_insurance_commercial"
                                  checked={
                                    demoDetails.chk_insurance_commercial
                                  }
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Commercial/private insurance
                                </span>
                              </label>
                            </div>
                            <div className="option-without-input">
                              <label>
                                <input
                                  type="checkbox"
                                  id="insurance_2"
                                  name="chk_insurance_medicare"
                                  checked={
                                    demoDetails.chk_insurance_medicare
                                  }
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Medicare
                                </span>
                              </label>
                            </div>
                            <div className="option-without-input">
                              <label>
                                <input
                                  type="checkbox"
                                  id="insurance_3"
                                  name="chk_insurance_medicaid"
                                  checked={
                                    demoDetails.chk_insurance_medicaid
                                  }
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Medicaid
                                </span>
                              </label>
                            </div>
                            <div className="option-without-input">
                              <label>
                                <input
                                  type="checkbox"
                                  id="insurance_4"
                                  name="chk_insurance_military"
                                  checked={
                                    demoDetails.chk_insurance_military
                                  }
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Military Insurance (Veterans Affairs or
                                  active military)
                                </span>
                              </label>
                            </div>
                            <div className="option-without-input">
                              <label>
                                <input
                                  type="checkbox"
                                  id="insurance_5"
                                  name="chk_insurance_oth"
                                  checked={demoDetails.chk_insurance_oth}
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Other insurance:
                                </span>
                                    <CustomTextArea
                                    id="txt_insurance_oth"
                                    name="txt_insurance_oth"
                                    value={demoDetails.txt_insurance_oth}
                                    onChange={HandleFieldChange}
                                      styles={{ marginLeft: "30px", width: "55%" }}
                                />
                              </label>
                            </div>
                            <div className="option-without-input">
                              <label>
                                <input
                                  type="radio"
                                  id="insurance_1"
                                  name="rbl_insurance"
                                  value={1}
                                  checked={
                                    demoDetails.rbl_insurance === Values.value1
                                  }
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  No insurance
                                </span>
                              </label>
                            </div>
                            <div className="option-without-input">
                              <label>
                                <input
                                  type="radio"
                                  id="insurance_99"
                                  name="rbl_insurance"
                                  value={99}
                                  checked={
                                    demoDetails.rbl_insurance ===
                                    Values.value99
                                  }
                                  onChange={HandleFieldChange}
                                />
                                <span className="radio-text-padding">
                                  Unknown
                                </span>
                              </label>
                            </div>
                          </div>
                          <ErrorField
                            show={hardErrList.insurance_commercial_empty}
                            message={CommonError_Msgs.Msg1}
                          />
                        </td>
                      </tr>

                      {/* Q8. */}
                      <tr>
                        <td className="containertd">
                          <div className="question question-weight">
                            <span>Q8.</span>
                            <span className="quest-text-pad">
                              MMA <i>mut</i> genotype in Human Genome
                              Variation Society (HGVS) notation.
                            </span>
                          </div>
                        </td>
                        <td >
                          <table className="nested-table">
                            <tr>
                              <th className="custom-right-border">First allele mutation </th>
                              <th>Second allele mutation </th>
                            </tr>
                            <tr>
                              <td className="containertd custom-left-border-disabled custom-bottom-border-disabled">
                                <div className="">
                                  <div className="option-without-input">
                                    <label className="option-fbox">
                                      <input
                                        type="radio"
                                        id="mma_mut_genotype_first_allele_1"
                                        name="rbl_mma_mut_genotype_first_allele"
                                        value={1}
                                        checked={
                                          demoDetails.rbl_mma_mut_genotype_first_allele ===
                                          Values.value1
                                        }
                                        onChange={HandleFieldChange}
                                      />

                                      <CustomTextArea
                                         id="txt_mma_mut_genotype_first"
                                         name="txt_mma_mut_genotype_first"
                                         value={
                                           demoDetails.txt_mma_mut_genotype_first
                                         }
                                         onChange={HandleFieldChange}
                                          styles={{ marginLeft: "0px", width: "85%" }}
                                      />
                                    </label>
                                  </div>
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="mma_mut_genotype__first_allele_99"
                                        name="rbl_mma_mut_genotype_first_allele"
                                        value={99}
                                        checked={
                                          demoDetails.rbl_mma_mut_genotype_first_allele ===
                                          Values.value99
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Unknown
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <ErrorField
                                  show={
                                    hardErrList.mma_mut_genotype_first_empty
                                  }
                                  message={CommonError_Msgs.Msg1}
                                />
                              </td>
                              <td className="containertd custom-right-border-disabled custom-bottom-border-disabled">
                                <div className="">
                                  <div className="option-without-input">
                                    <label className="option-fbox">
                                      <input
                                        type="radio"
                                        id="mma_mut_genotype__second_allele_1"
                                        name="rbl_mma_mut_genotype_second_allele"
                                        value={1}
                                        checked={
                                          demoDetails.rbl_mma_mut_genotype_second_allele ===
                                          Values.value1
                                        }
                                        onChange={HandleFieldChange}
                                      />

                                        <CustomTextArea
                                         id="txt_mma_mut_genotype_second"
                                         name="txt_mma_mut_genotype_second"
                                         value={
                                           demoDetails.txt_mma_mut_genotype_second
                                         }
                                         onChange={HandleFieldChange}
                                          styles={{ marginLeft: "0", width: "85%" }}
                                      />
                                    </label>
                                  </div>
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="mma_mut_genotype_second_allele_2"
                                        name="rbl_mma_mut_genotype_second_allele"
                                        value={2}
                                        checked={
                                          demoDetails.rbl_mma_mut_genotype_second_allele ===
                                          Values.value2
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Same as first allele
                                      </span>
                                    </label>
                                  </div>
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="mma_mut_genotype_second_allele_3"
                                        name="rbl_mma_mut_genotype_second_allele"
                                        value={3}
                                        checked={
                                          demoDetails.rbl_mma_mut_genotype_second_allele ===
                                          Values.value3
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        No mutation
                                      </span>
                                    </label>
                                  </div>
                                  <div className="option-without-input">
                                    <label>
                                      <input
                                        type="radio"
                                        id="mma_mut_genotype_second_allele_99"
                                        name="rbl_mma_mut_genotype_second_allele"
                                        value={99}
                                        checked={
                                          demoDetails.rbl_mma_mut_genotype_second_allele ===
                                          Values.value99
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Unknown
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <ErrorField
                                  show={
                                    hardErrList.mma_mut_genotype_second_empty
                                  }
                                  message={CommonError_Msgs.Msg1}
                                />

                              </td>
                            </tr>
                          </table>

                        </td>
                      </tr>

                      {/* Q9. to Q11. */}
                      <tr>
                        <td className="containertd" colSpan="2">
                          <div className="question-weight">
                            For questions Q9-Q11, please use the{" "}
                            <u>
                              assessment closest to and within 12 months
                              prior to
                            </u>{" "}
                            the index date (
                            <span className="indigo-text">
                              {dates.indexMinus365Days ||
                                indexMinus365DaysInit}
                            </span>{" "}
                            to{" "}
                            <span className="indigo-text">
                              {dates.indexMinus1Day || indexMinus1DayInit}
                            </span>
                            ).
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td colSpan="2" style={{ padding: 0 }}>
                          <table
                            style={{ width: "100%" }}
                            className="borderTable"
                          >
                            <thead>
                              <tr>
                                <th
                                  style={{
                                    borderRight: "1px solid black",
                                    borderLeft: "0",
                                    borderColor: "inherit",
                                    padding: "8px",
                                    textAlign: "center",
                                    minWidth: "200px",
                                  }}
                                >
                                  Type of Assessment
                                </th>
                                <th
                                  style={{
                                    borderRight: "1px solid black",
                                    borderColor: "inherit",
                                    padding: "8px",
                                    textAlign: "center",
                                    minWidth: "100px",
                                  }}
                                >
                                  Date of Assessment
                                </th>
                                <th
                                  style={{
                                    borderRight: "0",
                                    padding: "8px",
                                    textAlign: "center",
                                    minWidth: "300px",
                                  }}
                                >
                                  Measurement
                                </th>
                              </tr>
                            </thead>
                            <tbody
                              style={{
                                border: "0px",
                                borderColor: "inherit",
                              }}
                            >
                              {/* Row 1 */}
                              <tr>
                                <td
                                  className="containertd"
                                  style={{
                                    borderLeft: "0",
                                  }}
                                >
                                  <div className="question question-weight">
                                    <span>Q9.</span>
                                    <span className="quest-text-pad">
                                      Weight
                                    </span></div>
                                </td>
                                <td
                                  className="containertd"
                                >
                                  <>
                                    <div>
                                      <input
                                        type="radio"
                                        id="wt_assess_1"
                                        name="rbl_wt_assess"
                                        value={1}
                                        checked={
                                          demoDetails.rbl_wt_assess === Values.value1
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="date-field-padding-left">
                                        <DateControl
                                          ctrlId={"wt_assess_dt"}
                                          HandleDateChange={
                                            HandleDateChange
                                          }
                                          date={demoDetails.wt_assess_dt}
                                        />
                                      </span>
                                    </div>
                                    <div className="estimated-date-padding text-margin">
                                      <label>
                                        <input
                                          type="checkbox"
                                          id="chk_wt_assess_dt_est"
                                          name="chk_wt_assess_dt_est"
                                          checked={
                                            demoDetails.chk_wt_assess_dt_est
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Estimated date
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id="wt_assess_99"
                                          name="rbl_wt_assess"
                                          value={99}
                                          checked={
                                            demoDetails.rbl_wt_assess ===
                                            Values.value99
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Date unknown
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id="wt_assess_2"
                                          name="rbl_wt_assess"
                                          value={2}
                                          checked={
                                            demoDetails.rbl_wt_assess ===
                                            2
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Not assessed
                                        </span>
                                      </label>
                                    </div>
                                  </>
                                  <ErrorField
                                    show={hardErrList.wt_assess_empty}
                                    message={CommonError_Msgs.Msg1}
                                  />
                                  <ErrorField
                                    show={
                                      hardErrList.wt_assess_dt_empty ||
                                      hardErrList.wt_assess_dt_invalid
                                    }
                                    message={CommonError_Msgs.Msg2}
                                  />
                                </td>
                                {demoDetails.rbl_wt_assess === 2 ? (
                                  <td
                                    className="containertd"
                                    style={{
                                      textAlign: "center",
                                      borderRight: "0",
                                    }}
                                  >
                                    <span
                                      style={{ textAlign: "center" }}
                                      className="not-applicable"
                                    >
                                      <b>Not applicable</b>
                                    </span>
                                  </td>
                                ) : (
                                  <td
                                    className="containertd"
                                    style={{
                                      borderRight: "0",
                                    }}
                                  >
                                    <>
                                      <div>
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id="wt_measure_1"
                                            name="rbl_wt_measure"
                                            value={1}
                                            checked={
                                              demoDetails.rbl_wt_measure ===
                                              Values.value1
                                            }
                                            onChange={HandleFieldChange}
                                          />
                                          <input
                                            className="input-dash input-width"
                                            type="text"
                                            id="txt_wt_measure_lbs"
                                            name="txt_wt_measure_lbs"
                                            value={
                                              demoDetails.txt_wt_measure_lbs
                                            }
                                            onChange={HandleFieldChange}
                                            min={1}
                                            max={1400}
                                          />
                                          <span>lbs</span>
                                        </label>
                                      </div>
                                      <div>
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id="wt_measure_2"
                                            name="rbl_wt_measure"
                                            value={2}
                                            checked={
                                              demoDetails.rbl_wt_measure ===
                                              2
                                            }
                                            onChange={HandleFieldChange}
                                          />
                                          <input
                                            className="input-dash input-width"
                                            type="text"
                                            id="txt_wt_measure_kg"
                                            name="txt_wt_measure_kg"
                                            value={
                                              demoDetails.txt_wt_measure_kg
                                            }
                                            onChange={HandleFieldChange}
                                            min={1}
                                            max={630}
                                          />
                                          <span>kg</span>
                                        </label>
                                      </div>

                                      <div>
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id="wt_measure_99"
                                            name="rbl_wt_measure"
                                            value={99}
                                            checked={
                                              demoDetails.rbl_wt_measure ===
                                              Values.value99
                                            }
                                            onChange={HandleFieldChange}
                                          />
                                          <span>Unknown</span>
                                        </label>
                                      </div>
                                    </>
                                    <ErrorField
                                      show={hardErrList.wt_measure_empty}
                                      message={CommonError_Msgs.Msg1}
                                    />
                                    <ErrorField
                                      show={
                                        hardErrList.wt_measure_invalid
                                      }
                                      message={CommonError_Msgs.Msg2}
                                    />
                                  </td>
                                )}
                              </tr>

                              {/* Row 2 */}
                              <tr>
                                <td
                                  className="containertd"
                                  style={{
                                    borderLeft: "0",
                                  }}
                                >
                                  <div className="question question-weight">
                                    <span>Q10.</span>
                                    <span className="quest-text-pad">
                                      Height
                                    </span></div>

                                </td>
                                <td
                                  className="containertd"
                                >
                                  <>
                                    <div>
                                      <input
                                        type="radio"
                                        id="ht_assess_1"
                                        name="rbl_ht_assess"
                                        value={1}
                                        checked={
                                          demoDetails.rbl_ht_assess === Values.value1
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="date-field-padding-left">
                                        <DateControl
                                          ctrlId={"ht_assess_dt"}
                                          HandleDateChange={
                                            HandleDateChange
                                          }
                                          date={demoDetails.ht_assess_dt}
                                        />
                                      </span>
                                    </div>
                                    <div className="estimated-date-padding text-margin">
                                      <label>
                                        <input
                                          type="checkbox"
                                          id="ht_assess_dt_est"
                                          name="chk_ht_assess_dt_est"
                                          checked={
                                            demoDetails.chk_ht_assess_dt_est
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Estimated date
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id="ht_assess_2"
                                          name="rbl_ht_assess"
                                          value={2}
                                          checked={
                                            demoDetails.rbl_ht_assess ===
                                            2
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Same date as the weight
                                          assessment
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id="ht_assess_99"
                                          name="rbl_ht_assess"
                                          value={99}
                                          checked={
                                            demoDetails.rbl_ht_assess ===
                                            Values.value99
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Date unknown
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id="ht_assess_3"
                                          name="rbl_ht_assess"
                                          value={3}
                                          checked={
                                            demoDetails.rbl_ht_assess ===
                                            3
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Not assessed
                                        </span>
                                      </label>
                                    </div>
                                  </>
                                  <ErrorField
                                    show={hardErrList.ht_assess_empty}
                                    message={CommonError_Msgs.Msg1}
                                  />
                                  <ErrorField
                                    show={
                                      hardErrList.ht_assess_dt_empty ||
                                      hardErrList.ht_assess_dt_invalid
                                    }
                                    message={CommonError_Msgs.Msg2}
                                  />
                                </td>
                                {demoDetails.rbl_ht_assess === 3 ? (
                                  <td
                                    className="containertd"
                                    style={{
                                      textAlign: "center",
                                      borderRight: "0",
                                    }}
                                  >
                                    <span
                                      style={{ textAlign: "center" }}
                                      className="not-applicable"
                                    >
                                      <b>Not applicable</b>
                                    </span>
                                  </td>
                                ) : (
                                  <td
                                    className="containertd"
                                    style={{
                                      borderRight: "0",
                                    }}
                                  >
                                    <>
                                      <div className="date-field-padding">
                                        <label
                                          className="option-fbox"
                                          style={{ textWrap: "nowrap" }}
                                        >
                                          <div>
                                            <input
                                              type="radio"
                                              id="ht_measure_1"
                                              name="rbl_ht_measure"
                                              value={1}
                                              checked={
                                                demoDetails.rbl_ht_measure ===
                                                1
                                              }
                                              onChange={HandleFieldChange}
                                            />
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              flexWrap: "wrap",
                                              gap: "0 8px",
                                            }}
                                          >
                                            <input
                                              className="input-dash input-width"
                                              type="text"
                                              id="txt_ht_measure_ft"
                                              name="txt_ht_measure_ft"
                                              value={
                                                demoDetails.txt_ht_measure_ft
                                              }
                                              onChange={HandleFieldChange}
                                              min={0}
                                              max={9}
                                            />
                                            <span>feet and</span>
                                            <input
                                              className="input-dash input-width"
                                              type="text"
                                              id="txt_ht_measure_in"
                                              name="txt_ht_measure_in"
                                              value={
                                                demoDetails.txt_ht_measure_in
                                              }
                                              onChange={HandleFieldChange}
                                              min={0}
                                              max={11}
                                            />
                                            <span>inches</span>
                                          </div>
                                        </label>
                                      </div>
                                      <div>
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id="ht_measure_2"
                                            name="rbl_ht_measure"
                                            value={2}
                                            checked={
                                              demoDetails.rbl_ht_measure ===
                                              2
                                            }
                                            onChange={HandleFieldChange}
                                          />
                                          <input
                                            className="input-dash input-width"
                                            type="text"
                                            id="txt_ht_measure_cm"
                                            name="txt_ht_measure_cm"
                                            value={
                                              demoDetails.txt_ht_measure_cm
                                            }
                                            onChange={HandleFieldChange}
                                            min={1}
                                            max={300}
                                          />
                                          <span>centimeters</span>
                                        </label>
                                      </div>
                                      <div>
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id="ht_measure_99"
                                            name="rbl_ht_measure"
                                            value={99}
                                            checked={
                                              demoDetails.rbl_ht_measure ===
                                              Values.value99
                                            }
                                            onChange={HandleFieldChange}
                                          />
                                          <span>Unknown</span>
                                        </label>
                                      </div>
                                    </>
                                    <ErrorField
                                      show={hardErrList.ht_measure_empty}
                                      message={CommonError_Msgs.Msg1}
                                    />
                                    <ErrorField
                                      show={
                                        hardErrList.ht_measure_invalid
                                      }
                                      message={CommonError_Msgs.Msg2}
                                    />
                                  </td>
                                )}
                              </tr>

                              {/* Row 3 */}
                              <tr>
                                <td
                                  className="containertd"
                                  style={{
                                    borderBottom: "0",
                                    borderLeft: "0",
                                  }}
                                >
                                  <div className="question question-weight">
                                    <span>Q11.</span>
                                    <span className="quest-text-pad">
                                      Head circumference
                                    </span></div>
                                </td>
                                <td
                                  className="containertd"
                                  style={{
                                    borderBottom: "0",
                                  }}
                                >
                                  <>
                                    <div>
                                      <input
                                        type="radio"
                                        id="head_circ_assess_1"
                                        name="rbl_head_circ_assess"
                                        value={1}
                                        checked={
                                          demoDetails.rbl_head_circ_assess ===
                                          1
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="date-field-padding-left">
                                        <DateControl
                                          ctrlId={"head_circ_assess_dt"}
                                          HandleDateChange={
                                            HandleDateChange
                                          }
                                          date={
                                            demoDetails.head_circ_assess_dt
                                          }
                                        />
                                      </span>
                                    </div>
                                    <div className="estimated-date-padding text-margin">
                                      <label>
                                        <input
                                          type="checkbox"
                                          id="head_circ_assess_dt_est"
                                          name="chk_head_circ_assess_dt_est"
                                          checked={
                                            demoDetails.chk_head_circ_assess_dt_est
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Estimated date
                                        </span>
                                      </label>
                                    </div>
                              
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id="head_circ_assess_2"
                                          name="rbl_head_circ_assess"
                                          value={2}
                                          checked={
                                            demoDetails.rbl_head_circ_assess ===
                                            Values.value2
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Same as the weight assessment
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id="head_circ_assess_99"
                                          name="rbl_head_circ_assess"
                                          value={99}
                                          checked={
                                            demoDetails.rbl_head_circ_assess ===
                                            Values.value99
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Date unknown
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id="head_circ_assess_3"
                                          name="rbl_head_circ_assess"
                                          value={3}
                                          checked={
                                            demoDetails.rbl_head_circ_assess ===
                                            Values.value3
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Not assessed
                                        </span>
                                      </label>
                                    </div>
                                  </>
                                  <ErrorField
                                    show={
                                      hardErrList.head_circ_assess_empty
                                    }
                                    message={CommonError_Msgs.Msg1}
                                  />
                                  <ErrorField
                                    show={
                                      hardErrList.head_circ_assess_dt_empty ||
                                      hardErrList.head_circ_assess_dt_invalid
                                    }
                                    message={CommonError_Msgs.Msg2}
                                  />
                                </td>
                                {demoDetails.rbl_head_circ_assess ===
                                  3 ? (
                                  <td
                                    className="containertd"
                                    style={{
                                      textAlign: "center",
                                      borderBottom: "0",
                                      borderRight: "0",
                                    }}
                                  >
                                    <span
                                      style={{ textAlign: "center" }}
                                      className="not-applicable"
                                    >
                                      <b>Not applicable</b>
                                    </span>
                                  </td>
                                ) : (
                                  <td
                                    className="containertd"
                                    style={{
                                      borderBottom: "0",
                                      borderRight: "0",
                                    }}
                                  >
                                    <>
                                      <div>
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id="head_circ_measure_1"
                                            name="rbl_head_circ_measure"
                                            value={1}
                                            checked={
                                              demoDetails.rbl_head_circ_measure ===
                                              1
                                            }
                                            onChange={HandleFieldChange}
                                          />
                                          <input
                                            className="input-dash input-width"
                                            type="text"
                                            id="txt_head_circ_measure_in"
                                            name="txt_head_circ_measure_in"
                                            value={
                                              demoDetails.txt_head_circ_measure_in
                                            }
                                            onChange={HandleFieldChange}
                                            min={1}
                                            max={36}
                                          />
                                          <span>inches</span>
                                        </label>
                                      </div>
                                      <div>
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id="head_circ_measure_2"
                                            name="rbl_head_circ_measure"
                                            value={2}
                                            checked={
                                              demoDetails.rbl_head_circ_measure ===
                                              2
                                            }
                                            onChange={HandleFieldChange}
                                          />
                                          <input
                                            className="input-dash input-width"
                                            type="text"
                                            id="txt_head_circ_measure_cm"
                                            name="txt_head_circ_measure_cm"
                                            value={
                                              demoDetails.txt_head_circ_measure_cm
                                            }
                                            onChange={HandleFieldChange}
                                            min={1}
                                            max={100}
                                          />
                                          <span>centimeters</span>
                                        </label>
                                      </div>
                                      <div>
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id="head_circ_measure_99"
                                            name="rbl_head_circ_measure"
                                            value={99}
                                            checked={
                                              demoDetails.rbl_head_circ_measure ===
                                              Values.value99
                                            }
                                            onChange={HandleFieldChange}
                                          />
                                          <span>Unknown</span>
                                        </label>
                                      </div>
                                    </>
                                    <ErrorField
                                      show={
                                        hardErrList.head_circ_measure_empty
                                      }
                                      message={CommonError_Msgs.Msg1}
                                    />
                                    <ErrorField
                                      show={
                                        hardErrList.head_circ_measure_invalid
                                      }
                                      message={CommonError_Msgs.Msg2}
                                    />
                                  </td>
                                )}
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>

              <div className="survey-section-content-foot">
                <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Demographics;
